import { SplitContainer } from '@if/mui'
import { Card, CardContent, Skeleton, Stack } from '@mui/material'

/**
 * Placeholder shown by the calculator's PageContainer while the merchant
 * resources load — mirrors the loaded layout (fields column + estimate aside) so
 * the switch to real content doesn't shift.
 */
export const CalculatorSkeleton = () => (
  <SplitContainer
    main={
      <Stack spacing={3}>
        <Skeleton variant="rounded" height={120} />
        {/* Credit-rating selector: a 6-card radio grid (3 cols → 2 rows). */}
        <Skeleton variant="rounded" height={260} />
        <Skeleton variant="rounded" height={120} />
      </Stack>
    }
    aside={
      <Card>
        <CardContent>
          <Stack spacing={1}>
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="rounded" height={48} />
          </Stack>
        </CardContent>
      </Card>
    }
  />
)
